export default __webpack_public_path__ + "8cd0ccafbc91e37a67161e3df723cd05.svg";